/**
 * @author Andrés Camilo Ferreira Rodríguez
 * @Copyright (c) Infotrack. All rights reserved.
 */
import IProveedores from 'Infotrack@Modelos/smartStock/proveedores/entidades/proveedores';
import { TipoFormulario } from '@infotrack/presentacion-transversales/interfacesComunes';
import {
    manejadorIndicadorCargaGlobal,
    manejadorDialogoGlobal,
} from '@infotrack/presentacion-utilitarios/manejadoresComponentes';
import { useProveedor } from '@infotrack/presentacion-componentes/proveedorEstado';
import React from 'react';
import ProveedoresCM from '../controladorModelo/proveedoresCM';
import { acciones, IEstadoProveedores } from '../reductorProveedores';
import ProveedoresVista from '../vista/tablaProveedoresVista';
import Texto from '@infotrack/presentacion-componentes/texto';
import { useSelector } from 'react-redux';
import { IEstadoGlobal } from 'Infotrack@Reductores/interfacesReductores';

const proveedoresCM = new ProveedoresCM();

const TableProveedoresCV: React.FunctionComponent = () => {
    const cargaInicial = React.useRef(true);
    const [proveedoress, setProveedoress] = React.useState<IProveedores[]>([]);
    const [{ recargarTabla }, dispatch] = useProveedor<IEstadoProveedores>();
    const idEmpresa = useSelector((estado: IEstadoGlobal) => estado.estadoAutenticacion.usuarioInformacion!.IdEmpresa);

    React.useEffect(() => {
        if (recargarTabla || cargaInicial.current) {
            cargarProveedores();
            if (recargarTabla) {
                dispatch({ type: acciones.RECARGAR_TABLA });
            }
        }
        cargaInicial.current = false;
    });

    const cargarProveedores = () => {
        manejadorIndicadorCargaGlobal(true);
        proveedoresCM.consultarListaProveedoresPorEmpresaId(idEmpresa).then((proveedoress) => {
            setProveedoress(proveedoress);
            manejadorIndicadorCargaGlobal(false);
        });
    };
    const manejarFormulario = (tipoFormulario: TipoFormulario, entidadProveedores?: IProveedores) => {
        dispatch({ type: acciones.CAMBIAR_ESTADO_FORMULARIO, payload: { entidadProveedores, tipoFormulario } });
    };

    const confirmarEliminacion = (proveedores: IProveedores) => {
        manejadorDialogoGlobal({
            accionCancelar: () => manejadorDialogoGlobal({ estado: false }),
            accionConfirmar: () => eliminarProveedores(proveedores),
            estado: true,
            mensaje: <Texto id={'alerta.confirmacionEliminacion'} />,
            mostrarCancelar: true,
            tipoDialogo: 'Advertencia',
            titulo: <Texto id="titulo.advertencia" />,
        });
    };

    const eliminarProveedores = (proveedores: IProveedores) => {
        manejadorIndicadorCargaGlobal(true);
        manejadorDialogoGlobal({ estado: false });
        proveedoresCM.eliminarProveedores(proveedores).then(() => {
            manejadorIndicadorCargaGlobal(false);
            dispatch({ type: acciones.RECARGAR_TABLA });
        });
    };

    return (
        <ProveedoresVista
            proveedoress={proveedoress}
            cargarProveedores={cargarProveedores}
            confirmarEliminacion={confirmarEliminacion}
            manejarFormulario={manejarFormulario}
        />
    );
};

export default TableProveedoresCV;
